import React from "react";
import { connect } from "react-redux";
import { compose } from "redux";

import * as setupReducer from "containers/Setup/reducer";
import { getStep } from "containers/CreateWizard/reducer";

import UnderstandActions from "components/CreateWizard/Constraints/UnderstandActions";

class UnderstandActionsContainer extends React.PureComponent {
  render() {
    const { step, index } = this.props;

    return <UnderstandActions {...this.props} />;
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  updateTrueAction: (trueAction) => dispatch(setupReducer.updateTrueAction(ownProps.id, trueAction)),
  updateFalseAction: (falseAction) => dispatch(setupReducer.updateFalseAction(ownProps.id, falseAction))
});

const mapStateToProps = (state, ownProps) => ({
  trueAction: setupReducer.getTrueAction(state, ownProps.id),
  falseAction: setupReducer.getFalseAction(state, ownProps.id),

  step: getStep(state)
});

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export default compose(withConnect)(UnderstandActionsContainer);
